import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { CmpsDialogRef } from '@cmps/ng-uikit';

import { useDispatcher } from '../../../store.decorator';
import { defaultState } from '../evaluation/state';

import { TranslationKeyMap } from './ca-analysis-dialog.i18n';
import { CaAnalysisDialogService } from './ca-analysis-dialog.service';
import { minMax } from './state/min-max.action';

@Component({
    selector: 'cmps-ca-analysis-dialog',
    templateUrl: './ca-analysis-dialog.component.html',
    host: {
        class: 'cmps-ca-analysis-dialog',
    },
})
export class CaAnalysisDialogComponent implements AfterViewInit, OnDestroy {
    /** @private */
    _i18n = TranslationKeyMap;

    // @ViewChild('hudBtnTpl')
    // private readonly _hudBtnTpl: TemplateRef<any>;

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            CaAnalysisDialogComponent,
            void
        >,
        /** @private */ readonly _service: CaAnalysisDialogService,
    ) {
        defaultState();
    }

    ngAfterViewInit(): void {
        const buttons = [];
        // see meetingRequestContext?.evaluationEnabled
        if (
            this._service.callStatusService.callHandle?.streamTranscript ===
                true ||
            this._service.localCallCallService.callHandle?.streamTranscript ===
                true
        ) {
            // buttons.push(this._hudBtnTpl);
        }
        this._service.callStatusService.buttons = buttons;
        this._service.localCallCallService.buttons = buttons;
    }

    ngOnDestroy(): void {
        defaultState();
    }

    /** @private **/
    _onMinMaxClick(): void {
        useDispatcher(
            this._service,
            minMax({ minimized: !(this._service.state?.minimized ?? false) }),
        );
    }
}
